export default __webpack_public_path__ + "static/media/users.a2afd8f2.svg";